import { useState } from "react";
import { Platform } from "react-native";
import { ChatwootSheet } from "@louise/chatwoot";
import { useTranslations } from "@src/packages/i18n";
import type { PlanAction } from "../plan.types";
import { JourneyHandoffCard } from "./JourneyHandoffCard";
import { OrganicExplanatoryIllustration } from "./EggFreezingBiologyDeepCarouselCard";

const silkBrown =
  require("@src/apps/moon/assets/images/silk-brown.png") as number;

export function ExplorerJourneyHandoffCard({
  onAction,
}: {
  onAction: (action: PlanAction) => void;
}) {
  const t = useTranslations();
  const [textingAgentVisible, setTextingAgentVisible] = useState(false);
  const choosePathAction: PlanAction = {
    label: t("homepage.guided_precycle.actions.choose_path"),
    signal: "open-intent-picker",
  };
  const chatAction: PlanAction = {
    label: t("homepage.guided_precycle.learn_explorer.handoff_chat"),
    signal: "open-ai-chat",
    params: {
      initialPrompt: t(
        "homepage.guided_precycle.learn_explorer.handoff_chat_prompt",
      ),
    },
  };

  const handleChatPress = () => {
    if (Platform.OS === "web") {
      onAction(chatAction);
      return;
    }

    // Native users use the existing phone-native messaging/support channel
    // rather than being sent to the web-only Assistant route.
    setTextingAgentVisible(true);
  };

  return (
    <>
      <JourneyHandoffCard
        title={t("homepage.guided_precycle.learn_explorer.handoff_title")}
        body={t("homepage.guided_precycle.learn_explorer.handoff_body")}
        ctaLabel={t("homepage.guided_precycle.learn_explorer.handoff_cta")}
        checklist={[
          t("homepage.guided_precycle.learn_explorer.handoff_check_options"),
          t("homepage.guided_precycle.learn_explorer.handoff_check_numbers"),
          t("homepage.guided_precycle.learn_explorer.handoff_check_care"),
        ]}
        backgroundImage={silkBrown}
        illustration={<OrganicExplanatoryIllustration kind="follicle-cohort" />}
        onPress={() => onAction(choosePathAction)}
        secondaryAction={{
          label: t("homepage.guided_precycle.learn_explorer.handoff_chat"),
          onPress: handleChatPress,
        }}
      />
      <ChatwootSheet
        visible={textingAgentVisible}
        onClose={() => setTextingAgentVisible(false)}
      />
    </>
  );
}
